window.addEventListener('alpine:init', () => {
  function productSoldOutNotifyModal(data = {}) {
    var { removeSectionWrapper } = Alpine.store('utilities');

    return {
      ...data,

      isLoadingModal: false,

      onCommand(event) {
        if (event.command != 'show-modal') return;

        if (this.isLoadingModal) return;

        this.isLoadingModal = true;

        var url = `${location.origin}${event.source.dataset.href}`;

        var sectionUrl = new URL(url);

        sectionUrl.searchParams.set('section_id', this.sectionId);

        this.$refs.content.innerHTML = '';

        fetch(sectionUrl)
          .then((res) => {
            if (!res.ok) {
              throw new Error();
            }

            return res.text();
          })
          .then((res) => {
            var sectionHtml = removeSectionWrapper(res);

            this.$refs.content.innerHTML = sectionHtml;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.isLoadingModal = false;
          });
      }
    };
  };

  Alpine.data('productSoldOutNotifyModal', productSoldOutNotifyModal);
});
